import { Pipe, PipeTransform } from '@angular/core';

import { USStateOptions } from '../constants/us-state-options';

@Pipe({
  name: 'statesList',
  standalone: true
})
export class StatesListPipe implements PipeTransform {
  transform(stateCodes: any): string {
    const statesArray = [];
    stateCodes.forEach((sc) => {
      statesArray.push(USStateOptions.find((state) => state.value === sc)?.label || sc);
    });
    return statesArray.join(', ');
  }
}
